import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom'
import { ActionCable } from 'react-actioncable-provider';
import moment from 'moment'

import { Sidebar, Segment, Menu, Icon } from 'semantic-ui-react';
import 'semantic-ui-css/semantic.min.css';

import BootstrapTable from 'react-bootstrap-table-next';
import cellEditFactory from 'react-bootstrap-table2-editor';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';

import '../App.css';

import { logOutToken, refreshUser } from '../actions/app_token'
import { createNewPlan, updatePlan, getPlans, openPlanPage, deletePlan,
  deletePlanFailure, getPlansFailure, updatePlanFailure, createNewPlanFailure,
  getPlanTags, exportPlans, saveAsNewPlan, createNewPlanSuccess } from '../actions/plan'

import history from '../history'
import { store } from '../store';
import * as paths from '../constants'
import ConfirmToastr from '../components/confirm_toastr';
import CreatePlanModal from '../components/create_plan_modal';
import SystemHeader from '../components/system_header'
import Feedback from '../components/feedback'
import TagsDropdown from '../components/tags_dropdown'
import AppComponent from '../components/app_component'
import UserPlanPermissionTable from '../components/user_plan_permission_table'
import ElementLoader from '../components/element_loader'
import ControlsLink from '../components/controls_link'
import ExportModal from '../components/export_modal/index'
import ConfirmRemoveTagModal from '../components/confirm_remove_tag_modal/index';
import SavePlanAsModal from '../components/save_plan_as_modal';
import UnwantedEventLogsModal from './unwanted_event_logs_modal/unwanted_event_logs_modal'

import { getText } from '../helpers';
import ObjectITButton from '../components/developed_by_objectit';

import ToolTip from '../components/tool_tips/tool_tip';
import { toolTipManager } from '../services/instanceService';
import { 
  RISK_PLANS_NORMAL_USER_TIP_ID,
  RISK_PLANS_ADMIN_USER_TIP_ID,
  EXPORT_PLAN_TIP_ID,
  RISK_TEMPLATES_NORMAL_USER_TIP_ID,
  RISK_TEMPLATES_ADMIN_USER_TIP_ID
  } from '../constants';

class Dashboard extends AppComponent {
  constructor(props){
    super(props);

    this.state = {
      showExportModal: false,
      showConfirmRemoveTagModal: false,
      tagInFocus: null,
      rowInFocus: null,
      savePlanAsModalShown: false,
      plan: null
    }

    this.oldValue = null
    this.row = null

    this.timeStarted = null
  }

  componentWillMount = () => {
    if (!this.props.signedIn){
      return history.push(paths.LOGIN_PATH)
    }
    this.initializeState();
    this.initializeStateTableColumns();
  }

  componentDidMount = () => {
    var options = {
      search_term: this.state.searchTerm,
      is_template: (this.props.match.params.activeItem === 'risk_templates'),
      tag_filters: this.state.tagFilters
    }
    this.setState({ loading: true })
    this.props.getPlans(options).then(()=>{
      this.getTagOptions();
      this.setState({ loading: false })
    });
  }

  componentWillReceiveProps = (nextProps) => {
    var translations = nextProps.language.translations
    if (nextProps.language !== this.props.language){
      this.setState({
        language: nextProps.language,
        languages: nextProps.languages,
        translations: nextProps.language.translations,
        languageName: nextProps.language.name,
      }, ()=>{
        this.initializeStateTableColumns()
        this.forceUpdate();
      })
    }

    if (nextProps.getPlansPending){
      this.setState({
        notifications: "  (" + translations.fetching + "...)"
      });
      this.showNotifications(false);
    }

    if (nextProps.getPlansSuccess){
      if (nextProps.isTemplate){
        this.setState({
          templates: this.formatPlans(nextProps.plans),
          notifications: ""
        })
      }
      else {
        this.setState({
          plans: this.formatPlans(nextProps.plans),
          notifications: ""
        })
      }
      this.showNotifications(true);
      this.props.resetGetPlans();
    }

    if (nextProps.updatePending){
      this.setState({
        notifications: "  (" + translations.updating + "...)"
      });
      this.showNotifications(false);
    }

    if (nextProps.updateSuccess){
      this.setState({
        notifications: "  (" + translations.changes_to + " '"+ nextProps.plan.name +"' " + translations.has_been_saved + ".)"
      });
      this.showNotifications(true);
      this.props.resetUpdate();
    }

    if (nextProps.deletePending){
      this.setState({
        notifications: "  (" + translations.deleting + "...)"
      });
      this.showNotifications(false);
    }

    if (nextProps.deleteSuccess){
      this.setState({
        notifications: nextProps.plan.name + " " + translations.has_been_deleted + ".",
        loading: true,
      })
      this.showNotifications(true);
      this.props.resetDelete();
      var options = {
        search_term: this.state.searchTerm,
        is_template: (this.props.match.params.activeItem === 'risk_templates'),
        tag_filters: this.state.tagFilters,
        is_template: false,
      }

      if (nextProps.isTemplate){
        options.is_template = true
      }

      this.getPlans(options)
    }

    this.loadingMessage(nextProps.createPending);
    if (nextProps.createSuccess){
      this.props.resetCreate();
    }

  };

  initializeState = () => {
    this.setState({
      plans: [],
      templates: [],
      sidebarShown: false,
      pendingMessage: "",
      activeItem: this.props.match.params.activeItem,
      notifications: "",
      deletePlanModalShown: false,
      messageTimer: null,
      rowId: null,
      planName: null,
      createPlanModalShown: null,
      language: this.props.language,
      languages: this.props.languages,
      translations: this.props.language.translations,
      languageName: this.props.language.name,
      tagOptions: [
        'USA',
        'Chile',
        'Canada',
        'Ireland',
        'Peru'
      ],
      planRowEvents: {
        onDoubleClick: this.openPlan
      },
      templateRowEvents: {
        onDoubleClick: (this.props.isAdmin ? this.editTemplate : this.showCreatePlan)
      },
      searchTerm: '',
      tagFilters: [],
      userPlanPermissionTableModalOpen: false,
      loading: false,
    })
  }

  initializeStateTableColumns = () => {
    const { last_modified, date_created } = this.props.language.translations
    const plan_tags_header = `${getText('Plan-Tags')}: ${getText('Country')} - ${getText('Year')} - ${getText('Project Name')}`

    this.plansColumns = [
      {
        dataField: 'name',
        text: getText('Risk Plan Name'),
        formatter: (cell, row) => this.editableCell(cell, row, 'name'),
        headerTitle: true,
        title: true,
        headerStyle: {
          width: '22%'
        },
        editable: false
      },
      {
        dataField: 'tags',
        text: plan_tags_header,
        formatter: (cell, row) => this.tagsFormatter(cell, row),
        headerTitle: true,
        title: false,
        editable: false,
        headerStyle: {
          width: '30%'
        },
      },
      {
        dataField: 'updated_at',
        text: last_modified,
        formatter: this.cellFormatter,
        headerTitle: true,
        title: true,
        editable: false,
        headerStyle: {
          width: '11%'
        },
      },
      {
        dataField: 'created_at',
        text: date_created,
        formatter: this.cellFormatter,
        headerTitle: true,
        title: true,
        editable: false,
        headerStyle: {
          width: '11%'
        },
      },
      {
        dataField: 'buttons',
        text: '',
        formatter: (cell, row) => this.plansButtonsFormatter(cell, row),
        headerTitle: true,
        title: true,
        editable: false,
        headerStyle: {
          width: '23%'
        },
      },
    ]

    this.templatesColumns = [
      {
        dataField: 'name',
        text: getText('Risk Template Name'),
        formatter: (cell, row) => this.editableCell(cell, row, 'name'),
        headerTitle: true,
        title: true,
        headerStyle: {
          width: '55%'
        },
        editable: false
      },
      {
        dataField: 'updated_at',
        text: last_modified,
        formatter: this.cellFormatter,
        headerTitle: true,
        title: true,
        editable: false,
        headerStyle: {
          width: '12%'
        },
      },
      {
        dataField: 'created_at',
        text: date_created,
        formatter: this.cellFormatter,
        headerTitle: true,
        title: true,
        editable: false,
        headerStyle: {
          width: '12%'
        },
      },
      {
        dataField: 'buttons',
        text: '',
        formatter: (cell, row) => this.templatesButtonsFormatter(cell, row),
        headerTitle: true,
        title: true,
        editable: false,
        headerStyle: {
          width: '21%'
        },
      },
    ]
  }

  formatPlans = (plans) => {
    for(var i = 0; i < plans.length; i++) {
      var updated_at = new Date(plans[i].updated_at)
      plans[i].updated_at = moment(updated_at).format("DD MMM YYYY hh:mm A")
      var created_at = new Date(plans[i].created_at)
      plans[i].created_at = moment(created_at).format("DD MMM YYYY hh:mm A")
    }
    return plans
  }

  showNotifications = (timed) => {
    var notifs = document.getElementById("notifications");
    notifs.style.display = "inline";
    if (timed){
      setTimeout(()=>{ notifs.style.display = "none"; }, 3000);
    }
  }

  loadingMessage = (pending) => {
    var messageblock = document.getElementById("create-notification");
    if (pending){
      this.setState({
        pendingMessage: this.state.translations.fetching_plan
      })
      messageblock.style.display = "inline";
    }
    else {
      messageblock.style.display = "none";
    }
  };

  cellFormatter = (cell, row) => {
    return (
     <div className='cell-style'>
      { cell }
     </div>
    );
  }

  editableCell = (cell, row, column) => {
    const permission = this.getPermission(row.id)
    let can_update = permission && permission.can_update

    return (
     <div className='editable-cell-style' title={cell}>
      { !can_update && <span title={cell}>{ cell }</span>}
      {
        can_update &&
        <input
          type='text'
          className='editable-input no-focus'
          defaultValue={cell}
          onFocus={(evt)=>this.onCellFocus(evt, row)}
          onChange={(evt)=>this.onCellChange(evt, column)}
          onBlur={(evt)=>this.onCellBlur(evt)}
          onMouseDown={(evt)=>this.onCellMouseDown(evt)}
          onMouseUp={(evt)=>this.onCellMouseUp(evt)}
          readOnly={true}
        />
      }
     </div>
    );
  }

  tagsFormatter = (cell, row) => {
    return (
     <div className='cell-style' onClick={(evt)=>evt.stopPropagation()}>
      {
        row.tag_list.length > 0 &&
        <span className='tags-container'>
          {
            row.tag_list.map((tag, index)=>{
              return(
                <span key={index} className='tag plan-tag'>{tag} {this.props.isAdmin && <i aria-hidden="true" className="delete icon" onClick={(evt)=>this.handleRemoveTagEvent(tag, row)}></i>}</span>
              )
            })
          }
        </span>
      }
     </div>
    );
  }

  onCellFocus = (evt, row) => {
    this.oldValue = evt.target.value
    this.row = row
  }

  onCellChange = (evt, column) => {
    this.row[column] = evt.target.value
  }

  onCellBlur = (evt) => {
    if (this.oldValue !== evt.target.value){
      this.props.updatePlan(this.row)
    }
    this.setAsReadOnly(evt)
  }

  onCellMouseDown = (evt) => {
    this.timeStarted = new Date()
  }

  onCellMouseUp = (evt) => {
    this.timeEnded = new Date()
    var timeDiff = this.timeEnded - this.timeStarted
    if (timeDiff > 300){
      this.setAsEditable(evt)
    }
  }

  setAsEditable = (evt) => {
    evt.target.readOnly = false;
    evt.target.classList.remove('no-focus');
  }

  setAsReadOnly = (evt) => {
    evt.target.readOnly = true
    evt.target.classList.add('no-focus');
  }

  handleRemoveTagEvent = (tag, row) => {
    if (tag==='Active'){
      this.showConfirmRemoveTagModal({
        showConfirmRemoveTagModal: true,
        tagInFocus: tag,
        rowInFocus: row
      })
    } else {
      this.onRemoveTag(tag, row);
    }
  }

  showConfirmRemoveTagModal = (options) => {
    this.setState(options)
  }

  hideConfirmRemoveTagModal = (evt) => {
    this.setState({
      showConfirmRemoveTagModal: false,
      tagInFocus: null,
      rowInFocus: null
    })
  }

  proceedRemoveTag = (evt) => {
    var { tagInFocus, rowInFocus } = this.state
    this.onRemoveTag(tagInFocus, rowInFocus);
    this.hideConfirmRemoveTagModal();
  }

  onRemoveTag = (tag, row) => {
    var tagList = row.tag_list
    if (tagList.includes(tag)) {
      var index = tagList.indexOf(tag);
      if (index !== -1) tagList.splice(index, 1);
    }
    this.onApplyTags(tagList, row)
  }

  onApplyTags = (tagList, row) => {
    row.tag_list = tagList
    this.props.updatePlan(row)
  }

  onNewTag = (tag) => {
    var tagOptions = this.state.tagOptions
    if (!tagOptions.includes(tag)){
      tagOptions.splice(0,0,tag)
      this.setState({
        tagOptions: tagOptions
      })
    }
  }

  getTagOptions = () => {
    this.props.getPlanTags().then(()=>{
      var tagOptions = this.state.tagOptions
      tagOptions = tagOptions.concat(this.props.planTags)
      tagOptions = [...new Set(tagOptions)]
      this.setState({
        tagOptions: tagOptions
      })
    })
  }

  removeTagConfirmationCallback = (tag, row) => {
    this.showConfirmRemoveTagModal({
      showConfirmRemoveTagModal: true,
      tagInFocus: tag,
      rowInFocus: row
    })
  } 

  openScope = (plan) => {
    history.push({
      pathname: paths.PLAN_ACTIVITIES_PATH.replace(":plan_id", plan.id),
      state: { plan: plan }
    })
  }

  openUnwantedEventLogs = (planId) => {
    this.setState({ isUnwantedEventLogsOpen: true, selectedPlanId: planId })
  }

  closeUnwantedEventLogs = () => {
    this.setState({ isUnwantedEventLogsOpen: false, selectedPlanId: null })
  }

  plansButtonsFormatter = (cell, row) => {
    const { open, tags, tag_as } = this.state.translations
    const delete_label = this.state.translations.delete
    const trigger = (<a className='plan-action'>{tags}</a>)
    const permission = this.getPermission(row.id)

    return (
     <div className='cell-style'>
      <a className='plan-action' onClick={() => this.openScope(row)}>{open}</a>
      <a className='plan-action' style={{ marginLeft: 10 }} onClick={() => this.openUnwantedEventLogs(row.id)}>{getText("Change Logs")}</a>
      <span className='permission-indicator'>
        {
          !this.props.isAdmin && permission && permission.can_update &&
          <span><span className='red-text'>Edit</span></span>
        }
        {
          !this.props.isAdmin && permission && !permission.can_update &&
          <span><span className='blue-text'>View</span></span>
        }
      </span>
      { this.props.isAdmin &&
        <React.Fragment>
          <TagsDropdown
           className='tags-dropdown'
           trigger={trigger}
           header={`${tag_as}:`}
           translations={this.state.translations}
           tagList={row.tag_list}
           onApply={(tagList)=>this.onApplyTags(tagList, row)}
           tagOptions={this.state.tagOptions}
           onNewTag={this.onNewTag}
           addable={true}
           searchable={true}
           confirmRemove={true}
           confirmRemoveCallback={(tag)=>this.removeTagConfirmationCallback(tag, row)}
          />
          <a style={{margin: '0px 15px 0px 5px'}} className='plan-action' onClick={this.toggleUserPlanPermissions}>{ getText("Permissions") }</a>
          <a style={{margin: '0px 15px 0px 5px'}} className='plan-action' onClick={()=>this.toggleSaveAsPlanModal(row)}>{ getText("Save as") }</a>
          <a className='plan-action red' onClick={() => this.showDeletePlanModal(row)}>{delete_label}</a>
        </React.Fragment>
      }
      <ControlsLink plan_name={row.name} className='plan-action controls-link'/>
     </div>
    );
  }

  templatesButtonsFormatter = (cell, row) => {
    const create_plan = this.state.translations.create_plan
    const edit_template = this.state.translations.edit_template
    const create_button = <a className='plan-action' onClick={() => this.setState({createPlanModalShown: row.id})}>{create_plan}</a>
    return (
     <div className='cell-style'>
      {
        this.props.isAdmin && <a className='plan-action' style={{marginRight: 10}} onClick={() => history.push("/admin/" + row.id)}>{edit_template}</a>
      }
      {
        this.props.isAdmin &&
        <CreatePlanModal
          trigger={ create_button }
          shown={ this.state.createPlanModalShown === row.id }
          template={ row.name }
          onCreatePlan={ (planName, participants) => this.onCreatePlan(row.id, planName, participants) }
          onClose={ () => this.setState({createPlanModalShown: null}) }
          translations={this.state.translations}
          isAdmin={this.props.isAdmin}
          permissions={row.plan_permissions}
        />
      }
     </div>
    );
  }

  DeletePlanModal = () => {
    const { yes, no, sure_to_delete } = this.state.translations
    var message = sure_to_delete + " '"+ this.state.planName +"'?"
    
    return (
      <ConfirmToastr
        messageBody={message}
        messageType="info"
        messageYes={()=>this.props.deletePlan(this.state.rowId)}
        dismiss={ this.hideDeletePlanModal.bind(this) }
        options={{ yes: yes, no: no }}
        />
      )
  }

  showDeletePlanModal = (row) => {
    this.setState({
      deletePlanModalShown: true,
      rowId: row.id,
      planName: row.name
    })
  }

  hideDeletePlanModal = () => {
    this.setState({
      deletePlanModalShown: false
    })
  }

  toggleSideBar = () => {
    this.setState({ sidebarShown: true })
  }

  hideSideBar = () => {
    if (this.state.sidebarShown) {
      this.setState({ sidebarShown: false })
    }
  }

  updatePlan = (oldValue, newValue, row, column) => {
    if (oldValue !== newValue){
      this.props.updatePlan(row)
    }
  }

  onCreatePlan = (templateId, plan, participants) => {
    const newPlanParams = {
      plan_name: plan.name,
      plan_permissions: plan.plan_permissions,
      template_plan_id: templateId,
      participants: participants,
    }
    this.props.newPlan(newPlanParams)
    this.setState({ createPlanModalShown: null })
  }

  openPlan = (e, row, rowIndex) => {
    this.openScope(row)
  }

  showCreatePlan = (e, row, rowIndex) => {
    this.setState({createPlanModalShown: row.id})
  }

  editTemplate = (e, row, rowIndex) => {
    history.push("/admin/" + row.id)
  }

  onSearch = (evt) => {
    this.setState({
      searchTerm: evt.target.value,
      loading: true,
    })
    var options = {
      search_term: evt.target.value,
      is_template: false,
      tag_filters: this.state.tagFilters,
    }
    this.getPlans(options)
  }

  onFilterByTags = (tags) => {
    this.setState({
      tagFilters: tags,
      loading: true,
    })
    var options = {
      search_term: this.state.searchTerm,
      is_template: false,
      tag_filters: tags,
    }
    this.getPlans(options)
  }

  removeFromTagFilters = (tag) => {
    var tagList = this.state.tagFilters
    if (tagList.includes(tag)) {
      var index = tagList.indexOf(tag);
      if (index !== -1) tagList.splice(index, 1);
    }
    this.onFilterByTags(tagList)
  }

  clearFilters = (evt) => {
    this.setState({
      tagFilters: [],
      searchTerm: '',
      loading: true,
    })
    var options = {
      search_term: '',
      is_template: false,
      tag_filters: [],
    }

    this.getPlans(options)
  }

  getPlans = options => {
    return this.props.getPlans(options).then(() => {
      this.setState({ loading: false })
    })
  }

  toggleUserPlanPermissions = () => {
    const willOpen = !this.state.userPlanPermissionTableModalOpen
    const userPlanPermissionFilters = {}

    if( willOpen && this.state.searchTerm !== "" ||  this.state.tagFilters.length > 0 ){
      userPlanPermissionFilters.planIds = this.props.plans.map( plan => plan.id )
      userPlanPermissionFilters.searchTerm = this.state.searchTerm
      userPlanPermissionFilters.tagFilters = this.state.tagFilters
      return this.setState({ userPlanPermissionTableModalOpen: willOpen,
                             userPlanPermissionFilters: userPlanPermissionFilters })
    }

    this.setState({ userPlanPermissionTableModalOpen: willOpen, userPlanPermissionFilters: userPlanPermissionFilters })
  }

  exportPlans = (columns, plan_ids) => {
    var downloadId = moment(new Date).format("YYYYMMDDHHmmss");
    this.setState({
      loading: true,
      exportingToExcel: true,
      downloadId: downloadId
    })
    var options = this.generateOptions()
    options.plans_ids = plan_ids
    options.download_id = downloadId
    options.columns = columns.concat(['project_name'])
    this.props.exportPlans(options)
  }

  generateOptions = () => {
    const { languageName, searchTerm, tagFilters } = this.state;
    var search_term_placeholder = (searchTerm !== "" ? `-${searchTerm}` : '');
    var tag_filters_placeholder = (tagFilters.length > 0 ? `-${tagFilters.join('-')}` : '');
    var excel_filename = `Projects${search_term_placeholder}${tag_filters_placeholder}-${moment(new Date).format("YYYY-MMM-DD")}.xlsx`

    return {
      excel_filename: excel_filename,
      language: languageName
    }
  }

  toggleExportModal = (evt) => {
    this.setState({
      showExportModal: !this.state.showExportModal
    })
  }

  exportToFile = (type, columns, plan_ids) => {
    if (type==='Excel') {
      this.exportPlans(columns, plan_ids);
    }
  }

  exportChannelReceived = (received_data) => {
    if (received_data.status === 'excel-created' && received_data.download_id === this.state.downloadId){
      this.setState({
        loading:false,
        exportingToExcel: false,
        showExportModal: false
      })
      
      this.downloadExcelFile(received_data);
    }
  }

  downloadExcelFile = (received_data) => {
    var link = document.createElement('a');
    link.href = received_data.download_url;
    link.download = received_data.excel_filename;
    link.click();
  }

  toggleSaveAsPlanModal = (plan) => {
    this.setState({
      savePlanAsModalShown: !this.state.savePlanAsModalShown,
      plan: plan
    })
  }

  saveAsNewPlan = (planName, isTemplate) => {
    const cloneId = moment(new Date).format("YYYYMMDDHHmmss");
    this.setState({
      cloneId: cloneId,
      isTemplate: isTemplate,
      copyingSuccess: false
    })

    const { id, participants } = this.state.plan;
    const options = {
      plan_id: id,
      plan_name: planName,
      clone_id: cloneId,
      participants: participants,
      is_template: isTemplate
    }
    this.props.saveAsNewPlan(options)
  }

  clonePlanChannelReceived = (received_data) => {
    if (received_data.clone_id === this.state.cloneId){
      store.dispatch(createNewPlanSuccess(received_data.plan));
      store.dispatch(refreshUser(received_data.current_user));

      this.setState({ copyingSuccess: true })
      if (!this.state.isTemplate) {
        history.go(0)
      }
    }
  }

  render() {
        const { sidebarShown, activeItem, plans, templates, planRowEvents, templateRowEvents, showExportModal, exportingToExcel,
            translations, languageName, showConfirmRemoveTagModal, deletePlanModalShown, savePlanAsModalShown, plan, isUnwantedEventLogsOpen, 
            selectedPlanId } = this.state
    const { features } = this.props.instanceConfig || {};
    const { create_instruction, search_plans, filter_by_tags, filter_as, clear_filters } = this.state.translations
    const plansMenuClass =  history.location.pathname === '/dashboard/risk_plans' ? 'selected' : '';
    const templatesMenuClass =  history.location.pathname === '/dashboard/risk_templates' ? 'selected' : '';
    
    const riskPlansNormalUserTip = toolTipManager.getById(RISK_PLANS_NORMAL_USER_TIP_ID);
    const riskPlansAdminUserTip = toolTipManager.getById(RISK_PLANS_ADMIN_USER_TIP_ID);
    const exportPlansTip = toolTipManager.getById(EXPORT_PLAN_TIP_ID);
    const riskTemplatesNormalUserTip = toolTipManager.getById(RISK_TEMPLATES_NORMAL_USER_TIP_ID);
    const riskTemplatesAdminUserTip = toolTipManager.getById(RISK_TEMPLATES_ADMIN_USER_TIP_ID);

    console.log('features in dashboard', features);
    console.log('features tool_tips in dashboard', features && features.tool_tips);

    return (
      <div className="App">
        <Sidebar.Pushable as={Segment}>
          <Sidebar
            as={Menu}
            animation='overlay'
            width='thin'
            visible={sidebarShown}
            icon='labeled'
            vertical
            inverted
            onMouseLeave={() => this.hideSideBar()}
          >
            {
              this.props.isAdmin &&
              <Menu.Item className={templatesMenuClass} name='home' as={Link} to={paths.DASHBOARD_PATH + '/risk_templates'}>
                <span className="sidebar-button-wrap"><Icon name='file alternate'></Icon><div> {getText('Edit Template')}</div></span>
              </Menu.Item>
            }
            <Menu.Item className={plansMenuClass} name='home' as={Link} to={paths.DASHBOARD_PATH + '/risk_plans'}>
              <span className="sidebar-button-wrap"><Icon name='file alternate'></Icon><div> {getText('Open Plan')}</div></span>
            </Menu.Item>
            {
              this.props.isAdmin &&
              <React.Fragment>
                <Menu.Item as={Link} to={paths.LIBRARY_CONTROLS_PATH}>
                  <span className="sidebar-button-wrap"><Icon name='file'></Icon><div>{getText('Control Library')}</div></span>
                </Menu.Item>
                <Menu.Item name='users' as={Link} to={paths.USERS_PATH}>
                  <span className="sidebar-button-wrap"><Icon name='users'></Icon><div>{getText('Manage Users')}</div></span>
                </Menu.Item>
              </React.Fragment>
            }
            <Menu.Item name='send_feedback' onClick={()=>{}}>
              <span className="sidebar-button-wrap"><Feedback translations={this.state.translations}/></span>
            </Menu.Item>
            <Menu.Item>
              <ObjectITButton />
            </Menu.Item>
          </Sidebar>
          <Sidebar.Pusher>
            <Segment basic>
              <SystemHeader
                toggleSideBar={this.toggleSideBar}
                notifications={this.state.notifications}
                pendingMessage={this.state.pendingMessage}
                showLogout={true}
                view={this.props.isAdmin ? 'admin-dashboard' : 'dashboard'}
                showMenuButton={true}
                showLanguage={false}
              />
              <Menu>
                <Menu.Item
                  name='risk_plans'
                  active={activeItem === 'risk_plans'}
                  as={Link}
                  to={paths.DASHBOARD_PATH + '/risk_plans'}
                >
                  {getText('Risk Plans')}
                </Menu.Item>

                <Menu.Item
                  name='risk_templates'
                  active={activeItem === 'risk_templates'}
                  as={Link}
                  to={paths.DASHBOARD_PATH + '/risk_templates'}
                >
                  {getText('Risk Templates')}
                </Menu.Item>
                {
                  activeItem === 'risk_plans' &&
                  <Menu.Item
                    name='toolbar-item'
                    className='toolbar-item'
                  >
                    <form autoComplete="off">
                      <div className="ui input"><input type="text" placeholder={search_plans} value={this.state.searchTerm} onChange={this.onSearch} /></div>
                    </form>
                    {
                      <TagsDropdown
                       className='tags-dropdown'
                       trigger={(<a className='plan-action'>{filter_by_tags}</a>)}
                       header={`${filter_as}:`}
                       translations={this.state.translations}
                       tagList={this.state.tagFilters}
                       onApply={this.onFilterByTags}
                       tagOptions={this.state.tagOptions}
                       addable={false}
                       searchable={true}
                      />
                    }
                    {
                      this.state.tagFilters.length > 0 &&
                      <span className='tags-container'>
                        {
                          this.state.tagFilters.map((tag, index)=>{
                            return(
                              <span key={index} className='tag plan-tag'>{tag} <i aria-hidden="true" className="delete icon" onClick={(evt)=>this.removeFromTagFilters(tag)}></i></span>
                            )
                          })
                        }
                      </span>
                    }
                    <a className='plan-action' onClick={this.clearFilters}>{clear_filters}</a>
                    <React.Fragment>
                      {!exportingToExcel && <a className='plan-action export-selected-plans' onClick={this.toggleExportModal}>Export selected plans</a>}
                      { features && features.tool_tips && exportPlansTip && (
                        <div className="risk-plans-tool-tip-wrapper">
                          <ToolTip
                            title={exportPlansTip.title}
                            description={exportPlansTip.description}
                            video={exportPlansTip.video_link}
                            size='mini'
                          />
                        </div>
                      )}
                    </React.Fragment>
                    {
                      exportingToExcel && <a className='plan-action export-selected-plans exporting'>Exporting..<i className="loading circle notched icon"></i></a>
                    }
                    
                  </Menu.Item>
                }
                            { 
                activeItem === 'risk_plans' &&
                <div className="risk-plans-tool-tip-container">
                  { features && features.tool_tips && riskPlansNormalUserTip && !this.props.isAdmin &&(
                    <div className="risk-plans-tool-tip-wrapper">
                      <ToolTip
                        title={riskPlansNormalUserTip.title}
                        description={riskPlansNormalUserTip.description}
                        video={riskPlansNormalUserTip.video_link}
                        size="medium"
                      />
                    </div>
                  )}
                  { features && features.tool_tips && riskPlansAdminUserTip && this.props.isAdmin &&(
                    <div className="risk-plans-tool-tip-wrapper">
                      <ToolTip
                        title={riskPlansAdminUserTip.title}
                        description={riskPlansAdminUserTip.description}
                        video={riskPlansAdminUserTip.video_link}
                        size="medium"
                      />
                    </div>
                  )}
                </div>
              }
              {
                activeItem === 'risk_templates' &&
                <div className="risk-plans-tool-tip-container">
                  { features && features.tool_tips && riskTemplatesNormalUserTip && !this.props.isAdmin &&(
                    <div className="risk-plans-tool-tip-wrapper">
                      <ToolTip
                        title={riskTemplatesNormalUserTip.title}
                        description={riskTemplatesNormalUserTip.description}
                        video={riskTemplatesNormalUserTip.video_link}
                        size="medium"
                      />
                    </div>
                  )}
                  { features && features.tool_tips && riskTemplatesAdminUserTip && this.props.isAdmin &&(
                    <div className="risk-plans-tool-tip-wrapper">
                      <ToolTip
                        title={riskTemplatesAdminUserTip.title}
                        description={riskTemplatesAdminUserTip.description}
                        video={riskTemplatesAdminUserTip.video_link}
                        size="medium"
                      />
                    </div>
                  )}
                </div>
              }
              </Menu>
              { deletePlanModalShown && <this.DeletePlanModal /> }
              {
                activeItem === 'risk_plans' &&
                <div className="risks-table position-relative" id="risk-plans">
                  <ElementLoader isLoading={this.state.loading} />
                  <BootstrapTable
                    tdStyle={{ whiteSpace: 'normal' }} thStyle={{ whiteSpace: 'normal' }}
                    keyField="id"
                    data={ plans }
                    columns={ this.plansColumns }
                    cellEdit={ cellEditFactory({
                        mode: 'click',
                        blurToSave: true,
                        afterSaveCell: (oldValue, newValue, row, column) => { this.updatePlan(oldValue, newValue, row, column) }
                      })
                    }
                    striped
                    hover
                    condensed
                    noDataIndication={<span className="no-data-indication"><i className="file alternate icon"></i>{create_instruction}</span>}
                    rowEvents={planRowEvents}
                  />
                </div>
              }
              {
                activeItem === 'risk_templates' &&
                <div className="risks-table position-relative" id="risk-templates">
                  <ElementLoader isLoading={this.state.loading} />
                  <BootstrapTable
                    tdStyle={{ whiteSpace: 'normal' }} thStyle={{ whiteSpace: 'normal' }}
                    keyField="id"
                    data={ templates }
                    columns={ this.templatesColumns }
                    cellEdit={ cellEditFactory({ mode: 'click',blurToSave: true, afterSaveCell: (oldValue, newValue, row, column) => { this.updatePlan(oldValue, newValue, row, column) } }) }
                    striped
                    hover
                    condensed
                    noDataIndication={<span className="no-data-indication"><i className="file alternate icon"></i>{create_instruction}</span>}
                    rowEvents={templateRowEvents}
                  />
                </div>
              }
              { this.state.userPlanPermissionTableModalOpen &&
                <UserPlanPermissionTable
                  translations={this.state.translations}
                  plans={this.state.plans}
                  open={this.state.userPlanPermissionTableModalOpen}
                  close={this.toggleUserPlanPermissions}
                  filter={this.state.userPlanPermissionFilters}
                />
              }
              {
                showExportModal &&
                <ExportModal
                  type="Excel"
                  shown={showExportModal}
                  onExport={this.exportToFile}
                  pending={exportingToExcel}
                  onClose={()=>this.toggleExportModal()}
                  translations={translations}
                  languageName={languageName}
                  plans={plans}
                />
              }
              {
                showConfirmRemoveTagModal &&
                <ConfirmRemoveTagModal
                  shown={showConfirmRemoveTagModal}
                  onClose={this.hideConfirmRemoveTagModal}
                  onProceed={this.proceedRemoveTag}
                  translations={translations}
                />
              }
              {
                savePlanAsModalShown &&
                <SavePlanAsModal
                  plan={plan}
                  shown={savePlanAsModalShown}
                  onClose={()=>this.toggleSaveAsPlanModal()}
                  saveAsNewPlan={this.saveAsNewPlan}
                  loadingState={this.props.createPending}
                  translations={this.state.translations}
                  copyingSuccess={this.state.copyingSuccess}
                />
              }
              {
                isUnwantedEventLogsOpen &&
                <UnwantedEventLogsModal planId={selectedPlanId} onClose={this.closeUnwantedEventLogs} />
              }
              <ActionCable ref='exportChannel' channel={{channel: 'ExportChannel'}} onReceived={this.exportChannelReceived} />
              <ActionCable ref='clonePlanChannel' channel={{channel: 'ClonePlanChannel'}} onReceived={this.clonePlanChannelReceived} />
            </Segment>
          </Sidebar.Pusher>
        </Sidebar.Pushable>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    token: state.app_token.accessToken,
    user: state.app_token.user,
    signedIn: state.app_token.signedIn,
    isAdmin: state.app_token.isAdmin,
    user: state.app_token.user,
    plan: state.plan.plan,
    plans: state.plan.plans,
    getPlansSuccess: state.plan.getPlansSuccess,
    getPlansPending: state.plan.getPlansPending,
    isTemplate: state.plan.isTemplate,
    deleteSuccess: state.plan.deleteSuccess,
    deletePending: state.plan.deletePending,
    updateSuccess: state.plan.updateSuccess,
    updatePending: state.plan.updatePending,
    createSuccess: state.plan.createSuccess,
    createPending: state.plan.createPending,
    language: state.language.language,
    languages: state.language.languages,
    planTags: state.plan.planTags,
    instanceConfig: state.instance.instanceConfig
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    logout: (token) => {
      dispatch(logOutToken(token))
    },
    newPlan: options => {
      dispatch(createNewPlan(options))
    },
    updatePlan: (plan) => {
      dispatch(updatePlan(plan))
    },
    getPlans: (options) => dispatch(getPlans(options)),
    openPlanPage: (plan_id) => {
      openPlanPage(plan_id);
    },
    deletePlan: (plan_id) => {
      dispatch(deletePlan(plan_id));
    },
    resetDelete: () => {
      dispatch(deletePlanFailure());
    },
    resetGetPlans: () => {
      dispatch(getPlansFailure());
    },
    resetUpdate: () => {
      dispatch(updatePlanFailure());
    },
    resetCreate: () => {
      dispatch(createNewPlanFailure());
    },
    getPlanTags: () => dispatch(getPlanTags()),
    exportPlans: (options) => dispatch(exportPlans(options)),
    saveAsNewPlan: (options) => {
      dispatch(saveAsNewPlan(options))
    },
  }
}

let DashboardPage = connect(mapStateToProps, mapDispatchToProps)(Dashboard)
export default DashboardPage;



// WEBPACK FOOTER //
// ./src/views/dashboard.js